import { useEffect } from "react";
import type { SoundResponse } from "@wizard-sounds/shared";

export function useKeyboard(
  sounds: SoundResponse[],
  onPlay: (sound: SoundResponse) => void,
  onStopAll: () => void,
) {
  useEffect(() => {
    function handler(e: KeyboardEvent) {
      if (
        e.target instanceof HTMLInputElement ||
        e.target instanceof HTMLTextAreaElement ||
        e.target instanceof HTMLSelectElement
      ) {
        return;
      }

      if (e.code === "Space") {
        e.preventDefault();
        onStopAll();
        return;
      }

      if (e.key === "/") {
        e.preventDefault();
        const searchInput = document.querySelector<HTMLInputElement>('input[placeholder="Search sounds..."]');
        searchInput?.focus();
        return;
      }

      if (e.key >= "1" && e.key <= "9") {
        const idx = parseInt(e.key) - 1;
        if (idx < sounds.length) {
          e.preventDefault();
          onPlay(sounds[idx]);
        }
        return;
      }
    }

    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [sounds, onPlay, onStopAll]);
}
